import Header from "../components/Header";
import Footer from "../components/Footer";
import { useEffect } from "react";


export default function Home() {

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://files.coinmarketcap.com/static/widget/coinPriceBlock.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script); // Clean up on unmount
        };
    }, []);

    return (
        <>


            <Header />

            <main>

                <section class="pad hero-2">
                    <div class="data">
                        <h1 class="title">BLOCKCHAIN BASED TECHNICAL INFRASTRUCTURE</h1>
                        <div class="txt">
                            <p><span>Welcome to the {process.env.REACT_APP_PROJECT_NAME} platform: the multi-chain, interoperable network system availing
                                your optimal combination of private, public, open, permission and with degree of
                                decentralisation to suit.</span></p>
                            <p><span>Secured by dual layer internal and external Artificial intelligence (AI), it is gasless and
                                carbon neutral.</span></p>
                            <p><span>With unlimited scale and speed, the {process.env.REACT_APP_PROJECT_NAME} blockchain infrastructure is the substratum
                                for gasless interactive NFTs, augmented, and virtual reality. The backbone of the metaverse
                                and metarealm.</span></p>
                            <p><span>{process.env.REACT_APP_PROJECT_NAME} did not have an ICO. It funded a complete operational blockchain system itself
                                before NuCoin became available to the public from 23 December 2021. {process.env.REACT_APP_PROJECT_NAME} has been
                                working on enterprise and government solutions, particularly for countries seeking to
                                implement Central Bank Digital Currencies (CBDCs) and infrastructure instruments.
                                Accordingly {process.env.REACT_APP_PROJECT_NAME} re-engineered blockchain from inception. A "new" Genesis. New, not
                                only in different and fresh thinking, but "NU" as in N.U. – non-usury.</span></p>
                        </div>
                        <div class="btns">
                            <a href="doc/White_Papers.pdf" target="_blank" data-patt="track-btn" class="">WHITEPAPER</a>
                        </div>
                    </div>
                    <div class="image media-content-frame">
                        <video poster="" loop="true" autoplay="autoplay" muted="true" playsinline=""
                            src="media/NuGenesis_1.mp4"></video>
                    </div>
                    <div class="scroll">
                        <svg width="6.25rem" height="6.25rem" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M17.1628 1.44089C17.114 1.32523 17.0008 1.25 16.875 1.25L3.12503 1.25015C2.99945 1.25015 2.88608 1.32538 2.8371 1.44104C2.78827 1.5567 2.81344 1.69052 2.90103 1.78055L9.77603 8.85162C9.83478 8.91205 9.91565 8.94623 10 8.94623C10.0844 8.94623 10.1653 8.91205 10.224 8.85162L17.099 1.7804C17.1866 1.69022 17.2116 1.55655 17.1628 1.44089Z"
                                fill="#0CC2FF"></path>
                            <path
                                d="M17.1628 10.2885C17.114 10.1729 17.0008 10.0977 16.875 10.0977L3.12503 10.0978C2.99945 10.0978 2.88608 10.173 2.8371 10.2887C2.78827 10.4044 2.81344 10.5382 2.90103 10.6282L9.77603 17.6993C9.83478 17.7597 9.91565 17.7939 10 17.7939C10.0844 17.7939 10.1653 17.7597 10.224 17.6993L17.099 10.6281C17.1866 10.5379 17.2116 10.4042 17.1628 10.2885Z"
                                fill="#0CC2FF"></path>
                        </svg>
                        <span>SCROLL</span>
                    </div>
                </section>

                <section className="pad coinmarketcap-widget"> 
                    {/* 19211 */}
                    <div id="coinmarketcap-widget-coin-price-block" coins="1,1027,825,74,2010,1958,5426,1966" currency="USD" theme="light" transparent="false" show-symbol-logo="true"></div>
                </section>



                <h2 class="pad section-title">
                    <div class="content">
                        <div class="title"><i></i>About {process.env.REACT_APP_PROJECT_NAME}</div>
                    </div>
                </h2>

                <section class="pad about img-txt">
                    <div class="content-txt">
                        <div data-lavalamp=""></div>
                        <div data-lavalamp=""></div>
                        <div class="data">
                            <div class="text">
                                <img class="logo" src="images/logo.png" alt="" />
                                <div class="title">Crypto Banking App</div>
                                <p>{process.env.REACT_APP_PROJECT_NAME} is system of blockchain technologies to reap the potential in the mass adoption of
                                    the crypto market. It integrates blockchain load balancers and system validators to
                                    efficiently flow data into infinite parallel processing blockchains. The more users, the
                                    faster the transaction speed!

                                    {process.env.REACT_APP_PROJECT_NAME} parallel processing blockchains are multilingual cross chains allowing dApps built
                                    on Eth, Substrate, Bitcoin and 29 other language systems to be seamlessly interoperable.

                                    {process.env.REACT_APP_PROJECT_NAME} blockchain network configurations are complete and functional, and in-built in the
                                    code to constantly improve and innovate. It is entirely gasless. It is zero-carbon emission,
                                    and totally Green.</p>

                            </div>
                            <div class="img-frame crypto-paralax">
                                <video poster="" loop="true" autoplay="autoplay" muted="true" playsinline=""
                                    src="media/NuGenesis_2.mp4"></video>

                            </div>
                        </div>
                    </div>
                </section>

                <h2 class="pad section-title">
                    <div class="content">
                        <div class="title"><i></i>Media</div>
                    </div>
                </h2>

                <section class="pad video-text">
                    <div class="content">
                        <div data-lavalamp="" class="decor1" ></div>
                        <div data-lavalamp="" class="decor2"></div>
                        <div class="data">
                            <div class="title">Media</div>
                            <div class="txt">
                                <p>With unlimited scale and speed, the {process.env.REACT_APP_PROJECT_NAME} blockchain infrastructure is the substratum for
                                    gasless interactive NFTs, augmented, and virtual reality. The backbone of the metaverse and
                                    metarealm.</p>
                            </div>
                        </div>
                        <div class="video enable-iframe" >
                            <div class="img-frame">
                                <iframe width="100%" height="350" src="https://www.youtube.com/embed/AbmtlX11Iu0?si=hraoV-Evi4fF4XPu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </section>

                <h2 class="pad section-title" id="partners">
                    <div class="content">
                        <div class="title"><i></i>PRODUCTS</div>
                    </div>
                </h2>

                <section class="pad ecosystems">
                    <div class="head">
                        <div class="title">
                            Explore Our Premium Product Collection
                        </div>
                        <br />
                        <div class="subtitle">
                            With unlimited scale and speed, the {process.env.REACT_APP_PROJECT_NAME} blockchain infrastructure is the substratum for
                            gasless interactive NFTs, augmented, and virtual reality. The backbone of the metaverse and
                            metarealm. Learn more about our Projects.</div>
                    </div>
                    <div class="content">
                        <div>
                            <div class="pan">
                                <div class="head">

                                </div>
                                <div class="img-frame not-top">
                                    <video poster="" loop="true" autoplay="autoplay" muted="true" playsinline=""
                                        src="media/nft.mp4"></video>
                                </div>
                                <div class="data">
                                    <h3 class="title">NFT City.Exchange - Interactive NFT™ Platform</h3>
                                    <div class="txt">
                                        <p>{process.env.REACT_APP_PROJECT_NAME} Layer 1 NFT Platform is totally gasless. It is designed to encourage
                                            innovation. To encourage the shift from the rather static NFTs that are currently in
                                            existence, to more interactive NFTs. NFTs that transcend art into gaming.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="links">
                                <a href="#">Learn more</a>
                            </div>
                        </div>

                        <div>
                            <div class="pan">
                                <div class="head">

                                </div>
                                <div class="img-frame">
                                    <img src="images/nugenesisou/Nugenesisou 1 Dark.gif" alt="" />
                                </div>
                                <div class="data">
                                    <h3 class="title">The {process.env.REACT_APP_PROJECT_NAME} flagship: NU Coin</h3>
                                    <div class="txt">
                                        <p> {process.env.REACT_APP_PROJECT_NAME} flagship blockchain, NU Coin, is a fully operational and is already at
                                            zero-carbon emission. It is way past the POW vs POS debate!</p>
                                    </div>
                                </div>
                            </div>
                            <div class="links">
                                <a href="#">Learn more</a>
                            </div>
                        </div>
                    </div>

                    <div class="content">

                        <div>
                            <div class="pan">
                                <div class="head">

                                </div>
                                <div class="img-frame not-top">
                                    <video poster="" loop="true" autoplay="autoplay" muted="true" playsinline=""
                                        src="media/Troy-Gold-Backed.mp4"></video>
                                </div>
                                <div class="data">
                                    <h3 class="title">TROY Gold-backed token denominated in major currencies</h3>
                                    <div class="txt">
                                        <p> A troy is a token to represent the fiat currency representation in physical gold.
                                            For example Troy USD (TUSD) Troy Euro (TEURO) Troy AUD (TAUD) etc. It functions
                                            similar to a stable coin and a remittance tool.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="links">
                                <a href="#">Learn more</a>
                            </div>
                        </div>

                        <div>
                            <div class="pan">
                                <div class="head">

                                </div>
                                <div class="img-frame not-top">
                                    <video poster="" loop="true" autoplay="autoplay" muted="true" playsinline=""
                                        src="media/Smart-Contract.mp4"></video>
                                </div>
                                <div class="data">
                                    <h3 class="title">Next Generation Smart Contract Digital Notarised Contracts (DNC'S)</h3>
                                    <div class="txt">
                                        <p>The {process.env.REACT_APP_PROJECT_NAME} innovation to facilitate mass adoption by the mainstream economy is to
                                            go beyond existing limitations of smart contract protocols.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="links">
                                <a href="#">Learn more</a>
                            </div>
                        </div>

                        <div>
                            <div class="pan">
                                <div class="head">

                                </div>
                                <div class="img-frame not-top">
                                    <video poster="" loop="true" autoplay="autoplay" muted="true" playsinline=""
                                        src="media/ledx.mp4"></video>
                                </div>
                                <div class="data">
                                    <h3 class="title">The LedgerX Exchange Blockchain</h3>
                                    <div class="txt">
                                        <p>Ledger X is fully fledged (fiat/crypto) exchange where prices are determined by the
                                            brutality of the open market. It was designed to be an important part of the
                                            {process.env.REACT_APP_PROJECT_NAME} ecosystem to ensure capital is to be allocated by the market rather than
                                            bond curves and technocratic formulae.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="links">
                                <a href="#">Learn more</a>
                            </div>
                        </div>

                    </div>
                </section>





                <section class="pad crypto-card">
                    <div class="head">

                        <div class="subtitle">
                            Do you want to get involved and make your mark? <br />
                            Do you want to become a part of the {process.env.REACT_APP_PROJECT_NAME} community? <br />
                            Want to make a career, profession, or business in the new economy? <br />
                            Check out the opportunities in the {process.env.REACT_APP_PROJECT_NAME} ecosystem here: </div>
                    </div>
                    <div class="content">
                        <div data-lavalamp=""></div>
                        <div class="list enable-iframe">
                            <div class="shrink">

                                <iframe height="250" width="100%" src="https://www.youtube-nocookie.com/embed/KIlkhmxTi5M?si=6b9g8CvTKRJxSRBg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                            <div class="shrink">

                                <iframe height="250" width="100%" src="https://www.youtube.com/embed/D0WFAAlEGOs?si=tWVzvFwg7ZoKa8_a" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                            </div>
                            <div class="shrink">

                                <iframe height="250" width="100%" src="https://www.youtube.com/embed/plMKga9xAqE?si=7HGm37-IyRM36Rv_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                            </div>
                        </div>

                        <div class="list">
                            <div class="shrink">

                                <iframe height="250" width="100%" src="https://www.youtube.com/embed/gffjTUdgfDI?si=AMSwlfgweF1IHcTd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                            </div>
                            <div class="shrink">

                                <iframe height="250" width="100%" src="https://www.youtube.com/embed/LNuesj6LeRc?si=5_XXf26UgxhmrbWn" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                            </div>

                        </div>
                    </div>
                    <div class="btns">
                    </div>
                </section>

                <h2 class="pad section-title">
                    <div class="content">
                        <div class="title"><i></i>Community Participation</div>
                    </div>
                </h2>
                <section class="pad video-text community-video-text">
                    <div class="content">

                        <div class="community-video" data-modal-action="open" >

                            <div class="img-frame enable-iframe">
                                <iframe height="400" width="100%" src="https://www.youtube.com/embed/xMcCqJl4QA8">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </section>

                <h2 class="pad section-title">
                    <div class="content">
                        <div class="title"><i></i>NUGENESIS STRATEGIC PLAN</div>
                    </div>
                </h2>

                <section class="pad blockchain-ecosystem-schema">
                    <div class="head">
                        <div class="text">
                            Industry Historic Analysis todo with Financials, MetaRealm, Blockchain and environmental impact with a comparative overview </div>
                    </div>
                    <div class="schema">
                        <div class="item">
                            <div class="decor"></div>
                            <img src="images/wallet.svg" alt="" />
                            <span>
                                Money </span>
                        </div>
                        <div class="item">
                            <div class="decor"></div>
                            <img src="images/explorers.svg" alt="" />
                            <span>
                                Meta Realm </span>
                        </div>
                        <div class="item">
                            <div class="decor"></div>
                            <img src="images/products-serv.svg" alt="" />
                            <span>
                                Blockchain </span>
                        </div>
                        <div class="item">
                            <div class="decor"></div>
                            <img src="images/tools.svg" alt="" />
                            <span>
                                Societal Impact </span>
                        </div>

                        <div class="img-frame">
                            <img src="images/nugenesisou/Nugenesisou 2 Dark.gif" alt="" />
                        </div>

                        <div class="btns">
                        </div>

                        <div data-lavalamp=""></div>
                        <div data-lavalamp=""></div>
                    </div>
                </section>


            </main>

            <Footer />

            <div data-modal-name="license" data-modal-type="img">
                <div class="content">
                    <div class="close-x" data-modal-action="close"></div>
                    <img src="" alt="License" />
                </div>
            </div>

            <div data-modal-name="video" data-modal-type="img" data-modal-content-container=".video-frame"
                data-modal-video-autoplay="" data-modal-timeline=".5s">
                <div class="content">
                    <div class="close-x v2" data-modal-action="close"></div>
                    <div class="video-frame"></div>
                </div>
            </div>

            <div data-modal-name="video-not-autoplay" data-modal-type="img" data-modal-video-autoplay=""
                data-modal-content-container=".video-frame" data-modal-timeline=".5s">
                <div class="content">
                    <div class="close-x v2" data-modal-action="close"></div>
                    <div class="video-frame contain"></div>
                </div>
            </div>


        </>
    );
}
